import React from 'react';
import HeaderGlass from '../HeaderGlass';
import Footer from '../Footer';
import BackgroundImage from '../BackgroundImage';

const DesktopPanelLayout = ({ children }) => {
  return (
    <div className="desktop-layout desktop-layout--panel">
      <BackgroundImage 
        alt="Background"
        className="bg-img"
      />
      <HeaderGlass />
      <main className="desktop-layout__main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default DesktopPanelLayout;
